import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import {
    action,
    computed,
    extendObservable,
    makeObservable,
    observable,
    override,
    reaction,
    runInAction,
    toJS
} from 'mobx';
import moment from 'moment';
import Configuracao from '../util/Configuracao';
import NumeroProcessoUtil, {
    ESTRUTURA_NUMERO_PROCESSO_COM_CLASSE_PROCESSUAL,
    SEPARADOR_CLASSE_NUMERO_PADRAO
} from '../util/NumeroProcessoUtil';
import StringUtil from '../util/StringUtil';
import Store from './Store';
import { LOCALSTORAGE_STORAGE } from '@/util/StorageUtil';
import NomeUtil from '../util/NomeUtil';
dayjs.extend(customParseFormat);

export default class SessaoStore extends Store {
    modoAssinatura = Configuracao.MODO_ASSINATURA_SHODO;
    carregandoSessoes = false;
    carregandoSessao = false;
    carregandoPartes = false;
    carregandoJulgamentosAnteriores = false;
    carregandoMovimentacoesInternas = false;
    sessoesJulgamento = [];
    sessoesComPendencias = [];
    idSessaoSelecionada;
    sessaoSelecionada;
    composicaoPadraoOJC = [];
    exibirTodasAsSessoes = true;
    exibirSessoesPassadas = true;
    processoApregoado = undefined;
    relatorPregaoLote = undefined;
    notificacoesAlertaVotoAlterado = [];
    cronometro = {
        tempoEmSegundos: 600,
        tempoCorrendo: false,
        operacao: undefined
    };
    ordenandoProcessos = false;
    timerOrdenarProcessos;
    ordenacaoProcessosHabilitada = true;
    botaoOrdenacaoAcionado = false;
    mensagemOrdenacaoPendente = null;
    campoFocoPosOrdenacao;
    numeroProcessoFocoPosOrdenacao;
    pautaJulgamentoModal = undefined;
    carregandoPautaModal = false;
    tipoSessaoFiltrada = undefined;
    sessoesFiltradas = undefined;
    mapaProcessosPartesSessao = {};
    mapaMovimentacoesInternas = {};
    atualizacaoInformacoesProcessoHabilitada = true;
    alertaNovasInformacoesProcessoNaoAtualizadas = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            modoAssinatura: observable,
            carregandoSessoes: observable,
            carregandoSessao: observable,
            carregandoPartes: observable,
            carregandoJulgamentosAnteriores: observable,
            carregandoMovimentacoesInternas: observable,
            sessoesJulgamento: observable,
            sessoesComPendencias: observable,
            idSessaoSelecionada: observable,
            sessaoSelecionada: observable,
            composicaoPadraoOJC: observable,
            exibirTodasAsSessoes: observable,
            exibirSessoesPassadas: observable,
            processoApregoado: observable,
            relatorPregaoLote: observable,
            notificacoesAlertaVotoAlterado: observable,
            cronometro: observable,
            ordenandoProcessos: observable,
            ordenacaoProcessosHabilitada: observable,
            botaoOrdenacaoAcionado: observable,
            mensagemOrdenacaoPendente: observable,
            campoFocoPosOrdenacao: observable,
            numeroProcessoFocoPosOrdenacao: observable,
            pautaJulgamentoModal: observable,
            carregandoPautaModal: observable,
            tipoSessaoFiltrada: observable,
            sessoesFiltradas: observable,
            mapaProcessosPartesSessao: observable,
            mapaMovimentacoesInternas: observable,
            atualizacaoInformacoesProcessoHabilitada: observable,
            alertaNovasInformacoesProcessoNaoAtualizadas: observable,
            objetoLocalStorage: computed,
            resetNotificacoesVotoAlterado: action,
            descricaoSessaoNomeArquivoExportacao: computed,
            carregarPartesSessao: action,
            carregarJulgamentosAnteriores: action,
            carregarMovimentacoesInternas: action,
            receberAlteracaoSessaoEnvelope: action,
            receberAlteracaoProcessoEnvelope: action,
            receberResultadoJulgamentoLote: action,
            alterarResultadoJulgamento: action,
            recarregarProcesso: action,
            atualizarProcessoSessao: action,
            configurarProcessoApregoado: action,
            atualizarProcessoApregoado: action,
            receberAlteracaoMinutaEnvelope: action,
            receberOrdenarProcessosEnvelope: action,
            ordenarProcessosEnvelope: action,
            atualizarListaProcessos: action,
            receberPedidoVistaEnvelope: action,
            receberCronometroEnvelope: action,
            carregarSessaoJulgamento: action,
            carregarSessoesJulgamento: action,
            selecionarSessaoDefault: action,
            isPermitidaApreciacaoProcessosPJe: computed,
            configurarObservablesSessao: action,
            configurarProcessosSessao: action,
            configurarObservablesProcesso: action,
            parseNumeroProcesso: action,
            tratarRedatorPje: action,
            tratarPresidenteSessao: action,
            configurarComposicao: action,
            ordenarAdvogadosSustentacaoOral: action,
            segredoJustica: action,
            toggleExibirTodasAsSessoes: action,
            toggleExibirSessoesPassadas: action,
            sessoesPassadasFiltradas: computed,
            sessoesComProcessos: computed,
            sessoesJulgamentoFiltradas: computed,
            sessoesJulgamentoFiltradasOrdenadas: computed,
            isSessaoFinalizada: computed,
            recarregarListaProcessos: action,
            recarregarListaProcessosSemCache: action,
            atualizarQtdProcessosListaSessoes: action,
            composicaoPadraoOJCNormalizada: computed,
            inicializar: override,
            reset: override
        });

        this.createReaction(
            reaction(
                () => this.processoApregoado,
                () => {
                    if (this.processoApregoado) {
                        this.relatorPregaoLote = undefined;
                    }
                }
            )
        );
    }

    async inicializar() {
        super.inicializar();

        if (!this.rootStore.appStore.instalacaoShodoValida) {
            this.modoAssinatura = Configuracao.MODO_ASSINATURA_JTE;
        }

        if (!this.isComponenteHabilitado('ModoAssinatura')) {
            this.modoAssinatura = Configuracao.MODO_ASSINATURA_SHODO;
        }

        this.carregandoSessoes = true;
        await this.carregarComposicaoPadraoOJC();
        await this.carregarSessoesJulgamento();
        runInAction(() => (this.carregandoSessoes = false));
    }

    get storageType() {
        return LOCALSTORAGE_STORAGE;
    }

    get objetoLocalStorage() {
        return {
            nomeStore: 'SessaoStore',
            idSessaoSelecionada: this.idSessaoSelecionada,
            exibirTodasAsSessoes: this.exibirTodasAsSessoes,
            notificacoesAlertaVotoAlterado: this.notificacoesAlertaVotoAlterado || [],
            modoAssinatura: this.modoAssinatura
        };
    }

    reset() {
        super.reset();
        this.idSessaoSelecionada = undefined;
        this.sessaoSelecionada = undefined;
        this.sessoesJulgamento = [];
        this.resetNotificacoesVotoAlterado();
    }

    resetNotificacoesVotoAlterado() {
        if (this.notificacoesAlertaVotoAlterado) {
            this.notificacoesAlertaVotoAlterado = this.notificacoesAlertaVotoAlterado.filter((registro) =>
                moment(this.getDataSessao(registro.sessaoId), 'DD-MM-YYYY-HH-mm-ss')
                    .startOf('day')
                    .isSameOrAfter(moment().startOf('day'), 'day')
            );
        } else {
            this.notificacoesAlertaVotoAlterado = [];
        }
    }

    getDataSessao(sessaoId) {
        let sessao = this.sessoesJulgamento.find((sessao) => sessao.id === sessaoId);

        if (sessao) {
            return sessao.prazos.dataInicioSessaoPresencial;
        }

        return '01-01-1970-00-00-00';
    }

    get descricaoSessaoNomeArquivoExportacao() {
        const sessao = this.sessaoStore?.sessaoSelecionada;
        let descricao = '';

        if (sessao) {
            const ojc = sessao.orgaoJudicante.sigla || '';
            const tipo = sessao.tipo || '';
            let dataSessao;
            const formatoSaida = 'DD-MM-YYYY';

            if (
                sessao.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo &&
                sessao.prazos.dataInicioVotacaoVirtual
            ) {
                dataSessao =
                    dayjs(sessao.prazos.dataInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss').format(formatoSaida) +
                    '_a_' +
                    dayjs(sessao.prazos.dataFimVotacaoVirtualExibicao, 'DD-MM-YYYY-HH-mm-ss').format(formatoSaida);
            } else {
                dataSessao = dayjs(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').format(
                    formatoSaida
                );
            }

            descricao += ojc;
            descricao += tipo ? `_${tipo}` : '';
            descricao += dataSessao ? `_${dataSessao}` : '';
        }

        return descricao;
    }

    get dataHoraNomeArquivoExportacao() {
        /** 'YYYY-MM-DD_HH[h]mm[min]ss[s]' */
        const formatoDataHora = 'YYYYMMDDHHmmss';
        return dayjs().format(formatoDataHora);
    }

    montarNomeArquivoExportacao(nomeBase, extensaoArquivo = '.csv') {
        let nomeArquivo = '';

        if (nomeBase) {
            nomeArquivo += nomeBase;
        }

        const descricaoSessao = this.descricaoSessaoNomeArquivoExportacao
            ? '_' + this.descricaoSessaoNomeArquivoExportacao
            : '';
        const dataHoraGeracaoArquivoFormatada = this.dataHoraNomeArquivoExportacao
            ? '_' + this.dataHoraNomeArquivoExportacao
            : '';

        nomeArquivo += descricaoSessao + dataHoraGeracaoArquivoFormatada + extensaoArquivo;
        return nomeArquivo;
    }

    async inicializarSessaoJulgamento() {
        await this.createWhenReaction(() => this.sessoesJulgamento && this.sessoesJulgamento.length > 0);

        if (!this.isSessaoJulgamentoValida(this.idSessaoSelecionada)) {
            this.selecionarSessaoDefault();
        }

        if (!this.sessaoSelecionada || this.sessaoSelecionada.id !== this.idSessaoSelecionada) {
            runInAction(() => {
                this.carregandoSessao = true;
                this.processoApregoado = undefined;
                this.relatorPregaoLote = undefined;
            });

            this.resetNotificacoesVotoAlterado();
            await this.carregarSessaoJulgamento(this.idSessaoSelecionada);

            if (this.sessaoSelecionada) {
                this.configurarProcessoApregoado();
                this.configurarClienteEnvelope(this.sessaoSelecionada);
            }

            runInAction(() => (this.carregandoSessao = false));
        }
    }

    async carregarPartesSessao(sessaoId) {
        if (sessaoId && sessaoId !== -1) {
            this.carregandoPartes = true;
            let partes = await this.sessaoService.recuperarPartesSessao(sessaoId);

            if (partes) {
                runInAction(() => {
                    this.mapaProcessosPartesSessao = this.getMapaProcessosPartes(partes, sessaoId);
                    this.carregandoPartes = false;
                });
            } else {
                console.error(`Falha ao recuperar partes da sessão. [partes="${partes}" (tipo: ${typeof partes})]`);
            }
        }
    }

    async carregarJulgamentosAnteriores() {
        if (this.idSessaoSelecionada && !this.carregandoJulgamentosAnteriores) {
            this.carregandoJulgamentosAnteriores = true;

            try {
                const resultados = await this.sessaoService.recuperarJulgamentosAnterioresSessao(
                    this.idSessaoSelecionada
                );

                if (resultados && resultados.length > 0) {
                    await this.createWhenReaction(() => this.sessaoSelecionada?.processos);
                    resultados.forEach((resultado) => {
                        const numeroFormatadoResultado = NumeroProcessoUtil.formatarNumeroProcesso(resultado.numeroCompleto, false, true);
                        const registro = this.sessaoSelecionada.processos.find(
                            (reg) =>
                                NumeroProcessoUtil.formatarNumeroProcesso(reg.processo.numeroCompleto, false, true) ===
                                numeroFormatadoResultado
                        );

                        if (registro?.detalhes) {
                            runInAction(() => {
                                registro.detalhes.julgamentoAnterior = resultado.julgamentoAnterior;
                                registro.detalhes.julgamentosAnteriores = resultado.julgamentosAnteriores;
                            });
                        }
                    });
                }
            } finally {
                runInAction(() => (this.carregandoJulgamentosAnteriores = false));
            }
        }
    }

    async carregarMovimentosDecisoesSessaoSelecionada() {
        if (this.sessaoSelecionada) {
            let movimentosDecisoes = await this.sessaoService.recuperarMovimentosDecisoesSessao(
                this.sessaoSelecionada.id
            );

            if (movimentosDecisoes && movimentosDecisoes.length > 0 && this.sessaoSelecionada) {
                movimentosDecisoes.forEach((movimentoDecisao) => {
                    let registro = this.sessaoSelecionada.processos.find(
                        (reg) => reg.processo.numeroCompleto === movimentoDecisao.numero
                    );

                    if (registro) {
                        runInAction(() => {
                            registro.movimentos = movimentoDecisao.movimentos;
                            registro.informacaoProcessoSalaSessao.decisao = movimentoDecisao.decisao;
                        });
                    }
                });
            }
        }
    }

    configurarClienteEnvelope(sessao) {
        if (sessao?.id) {
            let idSessoes = sessao.id.split('----');

            if (!this.clienteEnvelopeService.estaAcompanhandoSessoes(idSessoes)) {
                this.clienteEnvelopeService.cancelarTodosAcompanhamentos();
                this.clienteEnvelopeService.acompanharSessoes(
                    idSessoes,
                    this.receberPregaoEnvelope.bind(this),
                    this.receberAlteracaoSessaoEnvelope.bind(this),
                    this.receberAlteracaoProcessoEnvelope.bind(this),
                    this.receberAlteracaoMinutaEnvelope.bind(this),
                    this.receberPedidoVistaEnvelope.bind(this),
                    this.receberOrdenarProcessosEnvelope.bind(this),
                    this.receberCronometroEnvelope.bind(this),
                    this.receberResultadoJulgamentoLote.bind(this)
                );
            }
        }
    }

    get clienteEnvelopeId() {
        return this.clienteEnvelopeService.clienteEnvelopeId;
    }

    setarValor(obj, str, val) {
        if (val === 'null') val = '';

        str = str.split('.');

        while (str.length > 1) {
            obj = obj[str.shift()];
        }
        return (obj[str.shift()] = val);
    }

    deveProcessarNotificacao(mensagem) {
        const notificacaoEnvelope = JSON.parse(mensagem.data);
        const clienteEnvelopeId =
            notificacaoEnvelope.clienteEnvelopeId &&
            notificacaoEnvelope.clienteEnvelopeId.length > 0 &&
            notificacaoEnvelope.clienteEnvelopeId[0];
        const clientId =
            notificacaoEnvelope.clientId && notificacaoEnvelope.clientId.length > 0 && notificacaoEnvelope.clientId[0];

        // Se a mensagem contiver clienteEnvelopeId, verifica se é igual ao clienteEnvelopeId local, sendo igual, descartar mensagem
        // Se a mensagem contiver clientId, verifica se é igual ao armazenado no token do Logus
        return (
            (clienteEnvelopeId && clienteEnvelopeId !== this.clienteEnvelopeService.clienteEnvelopeId) ||
            (clientId && clientId !== this.rootStore.usuarioStore.usuario.clientId) ||
            (!clienteEnvelopeId && !clientId)
        );
    }

    isAtualizacaoInformacoesProcessoHabilitada() {
        if (this.atualizacaoInformacoesProcessoHabilitada) {
            return true;
        } else {
            this.alertaNovasInformacoesProcessoNaoAtualizadas = true;
            return false;
        }
    }

    receberAlteracaoSessaoEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        if (this.deveProcessarNotificacao(mensagem)) {
            this.recarregarListaProcessos(false);
        }
    }

    receberAlteracaoProcessoEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        if (this.deveProcessarNotificacao(mensagem)) {
            let alteracaoProcesso = JSON.parse(mensagem.data);
            let numeroProcesso =
                alteracaoProcesso.processo && alteracaoProcesso.processo.length > 0 && alteracaoProcesso.processo[0];
            //remove fase se presente na numeracao do processo
            numeroProcesso = NumeroProcessoUtil.removerClasseProcessual(numeroProcesso);
            let registroParaAlterar = this.sessaoSelecionada.processos.find(
                (registro) => registro.numeroProcesso === numeroProcesso
            );
            this.alterarRegistro(registroParaAlterar, alteracaoProcesso);
        }
    }

    receberResultadoJulgamentoLote(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        let payload = JSON.parse(mensagem.data);
        let processos = Object.keys(payload.sequenciaisApregoamento);
        processos.forEach((numeroProcesso) => {
            let registroParaAlterar = this.sessaoSelecionada.processos.find(
                (registro) => registro.numeroProcesso === numeroProcesso
            );
            this.alterarResultadoJulgamento(registroParaAlterar, payload);
        });
    }

    alterarRegistro(registroParaAlterar, alteracaoProcesso) {
        if (registroParaAlterar) {
            let propriedade =
                alteracaoProcesso.propriedade &&
                alteracaoProcesso.propriedade.length > 0 &&
                alteracaoProcesso.propriedade[0];

            if (propriedade) {
                //eval(`registroParaAlterar.${propriedade} = alteracaoProcesso.valor && alteracaoProcesso.valor.length > 0 && alteracaoProcesso.valor[0]`);
                alteracaoProcesso.valor &&
                    alteracaoProcesso.valor.length > 0 &&
                    this.setarValor(registroParaAlterar, propriedade, alteracaoProcesso.valor[0]);
            } else {
                //se não foi informada a propriedade alterada, consulta o processo
                this.recarregarProcesso(registroParaAlterar);
            }
        }
    }

    alterarResultadoJulgamento(registroParaAlterar, payload) {
        if (registroParaAlterar) {
            registroParaAlterar.resultadoJulgamento = {
                descricao: payload.tipoResultadoJulgamento.descricao,
                id: payload.tipoResultadoJulgamento.id,
                codigo: payload.tipoResultadoJulgamento.id,
                julgado: payload.tipoResultadoJulgamento.julgado
            };
            registroParaAlterar.dataJulgamento = payload.dataJulgamento;
        }
    }

    async recarregarProcesso(registro, ignorarCacheServidor) {
        if (registro) {
            let novoRegistro = await this.sessaoService.recuperarProcessoSessao(
                registro.sessaoId,
                registro.processo.numeroCompleto,
                ignorarCacheServidor
            );
            //verificar processo em edição

            if (novoRegistro) {
                novoRegistro = this.configurarProcesso(observable(novoRegistro));

                runInAction(() => {
                    novoRegistro.detalhes = registro.detalhes;
                    novoRegistro.rascunhoCertidao = registro.rascunhoCertidao;
                    novoRegistro.rascunhoEmEdicao = registro.rascunhoEmEdicao;
                });

                await this.recuperarMovimentosDecisoes(novoRegistro);
                this.atualizarProcessoSessao(novoRegistro);
            }
        }
    }

    async recuperarMovimentosDecisoes(registro) {
        if (registro.processo.origem === Configuracao.ORIGEM_PJE) {
            let movimentos = await this.processoService.recuperarMovimentosProcesso(
                registro.sessaoId,
                registro.processo.numeroCompleto
            );
            runInAction(() => (registro.movimentos = movimentos));
        } else {
            let decisao = await this.processoService.recuperarDecisao(
                registro.sessaoId,
                registro.processo.numeroCompleto
            );
            runInAction(() => {
                registro.informacaoProcessoSalaSessao.decisao =
                    decisao && Object.keys(decisao).length > 0 ? decisao : undefined;
            });
        }
    }

    atualizarProcessoSessao(novoRegistro) {
        let indice = this.sessaoSelecionada?.processos?.findIndex(
            (reg) => reg.numeroProcesso === novoRegistro.numeroProcesso
        );

        if (indice > -1) {
            //campos de ordenação não são informados na consulta de único processo
            this.atualizarOrdemSessao(novoRegistro, this.sessaoSelecionada.processos[indice]);
            this.atualizarOrdemPregao(novoRegistro, this.sessaoSelecionada.processos[indice]);
            this.atualizarOrdemPreSessao(novoRegistro, this.sessaoSelecionada.processos[indice]);
            this.sessaoSelecionada.processos[indice] = novoRegistro;
            this.atualizarRegistroProcessoExpandido(novoRegistro);
            this.atualizarRegistroProcessoApregoado(novoRegistro);
            this.atualizarRegistroProcessoModal(novoRegistro);
        }
    }

    atualizarOrdemSessao(novoRegistro, registroAnterior) {
        if (!novoRegistro.ordemSessao) {
            novoRegistro.ordemSessao = registroAnterior.ordemSessao;
        }
    }

    atualizarOrdemPregao(novoRegistro, registroAnterior) {
        if (!novoRegistro.informacoesAdicionais.OrdemPregao) {
            novoRegistro.informacoesAdicionais.OrdemPregao = registroAnterior?.informacoesAdicionais?.OrdemPregao;
        }
    }

    atualizarOrdemPreSessao(novoRegistro, registroAnterior) {
        if (!novoRegistro.ordemPreSessao) {
            novoRegistro.ordemPreSessao = registroAnterior.ordemPreSessao;
        }
    }

    atualizarRegistroProcessoExpandido(novoRegistro) {
        if (
            this.storeFuncionalidade?.processoExpandido &&
            this.storeFuncionalidade.processoExpandido.processo.numeroCompleto === novoRegistro.processo.numeroCompleto
        ) {
            this.storeFuncionalidade.processoExpandido = novoRegistro;
        }
    }

    atualizarRegistroProcessoApregoado(novoRegistro) {
        if (
            this.processoApregoado &&
            this.processoApregoado.processo.numeroCompleto === novoRegistro.processo.numeroCompleto
        ) {
            this.processoApregoado = novoRegistro;
        }
    }

    atualizarRegistroProcessoModal(novoRegistro) {
        if (this.processoModal && this.processoModal.processo.numeroCompleto === novoRegistro.processo.numeroCompleto) {
            this.processoModal = novoRegistro;
        }
    }

    receberPregaoEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        const pregao = JSON.parse(mensagem.data);
        console.log('Pregao recebido!', pregao);
        const processoApregoado = {};
        const apregoado = pregao.apregoado && pregao.apregoado.length > 0 && pregao.apregoado[0];
        const marcarAusenciasAdvogados =
            Array.isArray(pregao.marcarAusenciasAdvogados) &&
            pregao.marcarAusenciasAdvogados.length > 0 &&
            StringUtil.stringToBoolean(pregao.marcarAusenciasAdvogados[0]);

        if (apregoado) {
            const ehProcesso = ESTRUTURA_NUMERO_PROCESSO_COM_CLASSE_PROCESSUAL.test(apregoado);

            if (ehProcesso) {
                processoApregoado.numeroProcessoFormatado = apregoado;
            } else {
                processoApregoado.relator = {};
                const siglaecpf = apregoado.split('-');
                processoApregoado.relator.sigla = siglaecpf[0];
                processoApregoado.relator.cpf = siglaecpf.length > 1 ? siglaecpf[1] : '';

                if (marcarAusenciasAdvogados) {
                    this.rootStore.salaSessaoStore.marcarAdvogadosAusentesLocalParaProcessosApregoaveisEmPlanilha(
                        processoApregoado.relator.sigla,
                        true
                    );
                }
            }
        }

        this.atualizarProcessoApregoado(processoApregoado);
    }

    async configurarProcessoApregoado() {
        try {
            let processoApregoado = await this.sessaoService.recuperarProcessoApregoado(
                this.usuarioStore.usuario.localizacao
            );
            this.atualizarProcessoApregoado(processoApregoado);
        } catch (error) {
            if (this.rootStore.routerStore.isSalaSessao) {
                this.rootStore.mensagemStore.abrirMensagemErro('Não foi possível recuperar o processo apregoado');
            }
            console.error(error);
        }
    }

    atualizarProcessoApregoado(processoApregoado) {
        if (processoApregoado) {
            if (processoApregoado.numeroProcessoFormatado) {
                console.log('Pregão do processo', processoApregoado.numeroProcessoFormatado);
                this.processoApregoado = this.processosSessao.find(
                    (registro) => registro.processo.numeroCompleto === processoApregoado.numeroProcessoFormatado
                );
            } else if (processoApregoado.relator) {
                console.log('Pregão de planilha', processoApregoado.relator.sigla);
                let relator = this.rootStore.dominioStore.magistrados.find(
                    (mag) =>
                        mag.sigla === processoApregoado.relator.sigla &&
                        (!processoApregoado.relator.cpf || mag.cpf === processoApregoado.relator.cpf)
                );

                if (relator) {
                    this.processoApregoado = undefined;
                    this.relatorPregaoLote = relator.sigla + '||' + relator.cpf + '||' + relator.nome;
                } else {
                    console.error(
                        'Relator não encontrado na lista de magistrados: ' +
                            processoApregoado.relator.sigla +
                            ' / ' +
                            processoApregoado.relator.cpf
                    );
                }
            } else {
                console.log('Pregão cancelado');

                if (this.processoApregoado) {
                    if (!this.isProcessoJulgado(this.processoApregoado)) {
                        this.processoApregoado.sequencialApregoamento = undefined;
                    }
                    this.processoApregoado = undefined;
                }

                if (this.relatorPregaoLote) {
                    this.relatorPregaoLote = undefined;
                }
            }
        }
    }

    isProcessoApreciado(registro) {
        return SituacaoJulgamentoProcessoBusiness.isProcessoApreciado(registro?.resultadoJulgamento);
    }

    isProcessoJulgado(registro) {
        return SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(registro?.resultadoJulgamento);
    }

    isImpedimentoComposicao(registro, impedimento) {
        return (
            registro.composicao?.findIndex(
                (composicao) =>
                    composicao.magistrado?.sigla === impedimento?.magistrado?.sigla ||
                    composicao.magistrado?.siglaSubstituto === impedimento?.magistrado?.sigla
            ) !== -1
        );
    }

    receberAlteracaoMinutaEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }

        let alteracaoMinuta = JSON.parse(mensagem.data);
        console.log('Alteração de minuta recebida!', alteracaoMinuta);
        let numeroProcesso =
            alteracaoMinuta.processo && alteracaoMinuta.processo.length > 0 && alteracaoMinuta.processo[0];
        let registroAlterado = this.processosSessao.find((registro) => registro.numeroProcesso === numeroProcesso);

        if (registroAlterado) {
            this.recarregarProcesso(registroAlterado);
            registroAlterado.alertarVotoAlterado = true;
            this.registrarNotificacaoAlteracaoVoto(registroAlterado);
        }
    }

    receberOrdenarProcessosEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }

        if (this.ordenacaoProcessosHabilitada || this.botaoOrdenacaoAcionado) {
            this.ordenandoProcessos = true;

            if (this.timerOrdenarProcessos) {
                clearTimeout(this.timerOrdenarProcessos);
            }
            this.timerOrdenarProcessos = setTimeout(() => this.ordenarProcessosEnvelope(mensagem), 2000);
        } else {
            this.mensagemOrdenacaoPendente = mensagem;
        }
    }

    ordenarProcessosEnvelope(mensagem) {
        if (this.sessaoSelecionada) {
            this.mensagemOrdenacaoPendente = null;
            this.botaoOrdenacaoAcionado = false;
            let numerosProcessosOrdenados = JSON.parse(mensagem.data);
            this.sessaoSelecionada.processos.forEach((registro) => {
                registro.ordemSessao = numerosProcessosOrdenados.findIndex(
                    (numeroProcesso) => numeroProcesso === registro.numeroProcesso
                );
            });
            this.atualizarListaProcessos();
            this.ordenandoProcessos = false;
        }
    }

    /**
     * Força a renderização da lista de processos.
     */
    atualizarListaProcessos() {
        this.sessaoSelecionada.processos = this.sessaoSelecionada.processos.slice();
    }

    receberPedidoVistaEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        let alteracaoProcesso = JSON.parse(mensagem.data);
        let clienteEnvelopeId =
            alteracaoProcesso.clienteEnvelopeId &&
            alteracaoProcesso.clienteEnvelopeId.length > 0 &&
            alteracaoProcesso.clienteEnvelopeId[0];

        //se a mensagem tiver clienteEnvelopeId, verifica se é igual ao clienteEnvelopeId local, sendo igual, descartar mensagem
        if (this.clienteEnvelopeService.clienteEnvelopeId !== clienteEnvelopeId) {
            let numeroProcesso =
                alteracaoProcesso.processo && alteracaoProcesso.processo.length > 0 && alteracaoProcesso.processo[0];
            //remove fase se presente na numeracao do processo
            numeroProcesso = NumeroProcessoUtil.removerClasseProcessual(numeroProcesso);
            let registroAlterado = this.sessaoSelecionada.processos.find(
                (registro) => registro.numeroProcesso === numeroProcesso
            );

            if (registroAlterado) {
                this.recarregarProcesso(registroAlterado);
            }
        }
    }

    registrarNotificacaoAlteracaoVoto(registroAlterado) {
        if (
            this.notificacoesAlertaVotoAlterado.findIndex(
                (registro) =>
                    registro.numeroProcesso === registroAlterado.numeroProcesso &&
                    registro.sessaoId === registroAlterado.sessaoId
            ) === -1
        ) {
            this.notificacoesAlertaVotoAlterado.push(registroAlterado);
        }
    }

    receberCronometroEnvelope(mensagem) {
        if (!this.isAtualizacaoInformacoesProcessoHabilitada()) {
            return;
        }
        let cronometroMsg = JSON.parse(mensagem.data);
        this.cronometro.operacao = cronometroMsg.operacao[0];

        if (cronometroMsg.operacao[0].toUpperCase() === 'INICIAR') {
            if (cronometroMsg.tempo && cronometroMsg.tempo[0]) {
                this.cronometro.tempoEmSegundos =
                    cronometroMsg.tempo[0] <= 0 ? this.cronometro.tempoEmSegundos : cronometroMsg.tempo[0];
            } else {
                this.cronometro.tempoEmSegundos = 600;
            }
        } else if (cronometroMsg.operacao[0].toUpperCase() === 'PARAR') {
            this.cronometro.tempoEmSegundos = 600;
        }
    }

    async carregarSessaoJulgamento(idSessaoJulgamento) {
        this.carregandoProcessos = true;
        let sessao = await this.sessaoService.recuperarSessaoJulgamento(idSessaoJulgamento);

        if (sessao && sessao.id === this.idSessaoSelecionada) {
            sessao = observable(sessao);
            this.configurarSessao(sessao);
            this.configurarProcessosSessao(sessao.processos);
            this.exibirErrosSessaoJulgamento(sessao);
            runInAction(() => (this.sessaoSelecionada = sessao));
        }
        runInAction(() => {
            this.carregandoProcessos = false;
        });
    }

    carregarSessoesComPendencias = async () => {
        if (this.sessoesJulgamento && this.sessoesJulgamento.length > 0) {
            let sessoesEncerradas = this.sessoesJulgamento.filter((sessao) => sessao.situacao === 'ENCERRADA');

            if (sessoesEncerradas.length > 0) {
                let sessoesComPendencias = await this.sessaoService.listarSessoesPendentes(
                    sessoesEncerradas.map((sessao) => sessao.id)
                );
                runInAction(() => (this.sessoesComPendencias = sessoesComPendencias));
            }
        }
    };

    carregarComposicaoPadraoOJC = async () => {
        // TODO Consulta aguardando implementação nos TRT's. No TST já está disponível
        if (this.isComponenteHabilitado('ConsultaComposicaoPadrao')) {
            let usuario = this.rootStore.usuarioStore.usuario;

            if (usuario?.localizacao) {
                let composicao = await this.sessaoService.recuperarComposicaoPadraoOJC(usuario.localizacao);
                composicao.forEach((comp) => {
                    comp.texto = comp.titular.sigla;
                    comp.textoSecundario = NomeUtil.ajustarCaixaNomeProprio(comp.titular.nome);
                });
                runInAction(() => (this.composicaoPadraoOJC = composicao));
            }
        }
    };

    carregarSessoesJulgamento = async () => {
        let usuario = this.rootStore.usuarioStore.usuario;

        if (usuario?.localizacao) {
            let sessoes = await this.sessaoService.recuperarSessoesJulgamento(usuario.localizacao);
            runInAction(() => (this.sessoesJulgamento = sessoes));
        }
    };

    async carregarMovimentacoesInternas(sessaoId) {
        if (sessaoId && sessaoId !== -1) {
            this.carregandoMovimentacoesInternas = true;
            let movimentacoes = await this.sessaoService.recuperarMovimentacoesInternas(sessaoId);

            if (movimentacoes) {
                runInAction(() => {
                    this.mapaMovimentacoesInternas = this.getMapaMovimentacoesInternas(movimentacoes);
                    this.carregandoMovimentacoesInternas = false;
                });
            } else {
                console.error(`Falha ao recuperar movimentações internas da sessão. [movimentacoes="${movimentacoes}" (tipo: ${typeof movimentacoes})]`);
            }
        }
    }

    getMapaMovimentacoesInternas(movimentacoes) {
        let mapa = {};
        for (let movimentacao of movimentacoes) {
            mapa[movimentacao.numeroProcesso] = movimentacao;
        }
        return mapa;
    }

    // Se não houver sessão selecionada e houver próxima sessão na lista, seleciona a próxima sessão
    selecionarSessaoDefault = () => {
        let sessoes = this.sessoesJulgamento;

        if (sessoes && sessoes.length > 0) {
            let sessoesHoje = sessoes.filter((sessao) => sessao.hoje);

            if (sessoesHoje.length > 0) {
                this.idSessaoSelecionada = this.getIdSessaoDefault(sessoesHoje);
            } else {
                let sessaoAnterior = this.getSessaoAnterior(sessoes);

                if (
                    sessaoAnterior &&
                    moment(sessaoAnterior.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                        .startOf('day')
                        .isSameOrAfter(moment().startOf('day').subtract(2, 'days'), 'day')
                ) {
                    this.idSessaoSelecionada = sessaoAnterior.id;
                } else {
                    let proximasSessoes = sessoes.filter((sessao) => sessao.proxima);

                    if (proximasSessoes.length > 0) {
                        this.idSessaoSelecionada = this.getIdSessaoDefault(proximasSessoes);
                    } else {
                        this.idSessaoSelecionada = this.getIdSessaoDefault(sessoes);
                    }
                }
            }
        }
    };

    get isPermitidaApreciacaoProcessosPJe() {
        if (!this.sessaoStore?.sessaoSelecionada) return false;
        return (
            this.sessaoStore.sessaoSelecionada.sessoes.findIndex(
                (sessao) =>
                    this.isSessaoPJe(sessao.id) &&
                    this.sessaoStore.sessaoSelecionada.quantidadesTotaisProcessos[sessao.id] > 0 &&
                    (this.sessaoStore.sessaoSelecionada.situacoes[sessao.id] === Configuracao.STATUS_INICIADA ||
                        this.sessaoStore.sessaoSelecionada.situacoes[sessao.id] ===
                            Configuracao.STATUS_PLENARIO_VIRTUAL)
            ) !== -1
        );
    }

    getSessaoAnterior(sessoes) {
        return sessoes.find((sessao) =>
            moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').isBefore(moment(), 'day')
        );
    }

    getIdSessaoDefault(sessoes) {
        let retorno = -1;

        if (sessoes && sessoes.length > 0) {
            retorno = sessoes[0].id;

            if (sessoes.length > 1) {
                const sessoesIniciadas = sessoes.filter(
                    (sessao) =>
                        sessao.situacao === Configuracao.STATUS_INICIADA ||
                        sessao.situacao === 'NAO_GERENCIADA_INICIADA'
                );

                if (sessoesIniciadas.length > 0) {
                    retorno = this.getIdSessaoMaisProxima(sessoesIniciadas);
                } else {
                    retorno = this.getIdSessaoMaisProxima(sessoes);
                }
            }
        }
        return retorno;
    }

    getIdSessaoMaisProxima(sessoes) {
        let retorno = -1;

        if (sessoes && sessoes.length > 0) {
            let sessaoMaisProxima = sessoes.find((sessao) =>
                moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').isSameOrBefore(moment())
            );

            if (sessaoMaisProxima) {
                retorno = sessaoMaisProxima.id;
            } else {
                let sessoesOrdenadas = sessoes
                    .slice()
                    .sort((s1, s2) =>
                        moment(s1.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').isSameOrBefore(
                            moment(s2.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                        )
                            ? -1
                            : 1
                    );
                sessaoMaisProxima = sessoesOrdenadas.find((sessao) =>
                    moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss').isSameOrAfter(moment())
                );

                if (sessaoMaisProxima) {
                    retorno = sessaoMaisProxima.id;
                }
            }
        }
        return retorno;
    }

    exibirErrosSessaoJulgamento(sessao) {
        if (sessao) {
            for (let erro of sessao.erros ? sessao.erros : []) {
                this.rootStore.mensagemStore.abrirMensagemErro(erro);
            }
        }
    }

    isSessaoJulgamentoValida(idSessaoJulgamento) {
        if (this.sessoesJulgamento && this.sessoesJulgamento.length > 0 && idSessaoJulgamento) {
            return this.sessoesJulgamento.findIndex((sessao) => sessao.id === idSessaoJulgamento) !== -1;
        }
        return false;
    }

    configurarSessao(sessao) {
        if (sessao) {
            this.configurarObservablesSessao(sessao);
        }
        return sessao;
    }

    configurarObservablesSessao(sessao) {
        this.adicionarObservable(sessao, 'sessoes');
        sessao.sessoes = this.converterSessaoComposta(sessao);
    }

    converterSessaoComposta(sessao) {
        if (sessao?.id) {
            let idSessoes = sessao.id.split('----');
            let origemSessoes = [];
            let descricaoSessoes = [];
            idSessoes.forEach((idSessao) => {
                let temp = idSessao.split('--');
                origemSessoes.push(temp[0]);
                descricaoSessoes.push(temp[0] + ' ' + temp[1].split('-')[0]);
            });
            return idSessoes.map((idSessao, index) => ({
                id: idSessao,
                descricao: descricaoSessoes[index],
                origem: origemSessoes[index],
                procurador: undefined
            }));
        }
        return [];
    }

    configurarProcessosSessao(processos) {
        if (processos && processos.length > 0) {
            processos.forEach((registro, index) => {
                this.configurarProcesso(registro, index);
            });
        }
    }

    configurarProcesso(registro, index) {
        this.configurarObservablesProcesso(registro, index);
        this.tratarRedatorPje(registro);
        this.tratarPresidenteSessao(registro);
        this.configurarComposicao(registro);
        this.ordenarAdvogadosSustentacaoOral(registro);
        this.tratarProcurador(registro);
        return registro;
    }

    configurarObservablesProcesso(registro, index) {
        const classeNumero = registro.processo.numeroCompleto.split(SEPARADOR_CLASSE_NUMERO_PADRAO);

        const processoAtual = this.processosSessao.find(
            (registroSessao) =>
                registroSessao.numeroProcesso ===
                NumeroProcessoUtil.removerClasseProcessual(registro.processo.numeroCompleto)
        );

        extendObservable(registro, {
            rendered: processoAtual?.rendered ?? false,
            renderedOperacoesEmLote: false,
            linha: false,
            checkedLiberarDispositivoVoto: true,
            checkedEnviarProcessoOrigem: false,
            checkedPublicacaoPauta: false,
            classeProcesso: classeNumero[0],
            numeroProcesso: classeNumero[1],
            objetoNumeroProcesso: this.parseNumeroProcesso(classeNumero[1]),
            segredoJustica: this.segredoJustica(registro.processo),
            ementa: undefined,
            decisao: undefined,
            rascunhoCertidao: undefined,
            rascunhoEmEdicao: false,
            conteudoVoto: undefined,
            pecas: undefined,
            detalhes: {},
            alertasImpedimento: [],
            lancarCertidao: false,
            lancarAcordao: false,
            lancarMovimentos: false,
            transcendencia: false,
            bloqueioBaixa: false,
            alertarVotoAlterado: false,
            conteudoCertidao: undefined
        });

        this.adicionarObservable(registro, 'ordemSessao', index);
        this.adicionarObservable(registro, 'dataJulgamento');
        this.adicionarObservable(registro, 'confirmadaInclusaoPauta', false);
        this.adicionarObservable(registro, 'confirmadaPublicacaoPauta', false);

        this.adicionarObservable(registro.processo, 'redator', {});
        this.adicionarObservable(registro.processo.redator, 'sigla');

        this.adicionarObservable(registro, 'presidenteSessaoJulgamento', {});
        this.adicionarObservable(registro.presidenteSessaoJulgamento, 'sigla');

        this.adicionarObservable(registro, 'detalhes', {});

        this.adicionarObservable(registro, 'informacaoProcessoSalaSessao', {});
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'anotacao');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'complementoAnotacoes');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'ordenacaoSecretario');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'sequenciaPreferencia');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'decisao');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'magistradoVistaEmMesa');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'votoAnalisado');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'votoAlterado');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'votoNulo');
        this.adicionarObservable(registro.informacaoProcessoSalaSessao, 'tipoValidacao');

        this.adicionarObservable(registro, 'resultadoJulgamento');
        this.adicionarObservable(registro.resultadoJulgamento, 'codigo');

        this.adicionarObservable(registro, 'informacoesAdicionais', {});
        this.adicionarObservable(registro.informacoesAdicionais, 'OrdemPregao');

        this.adicionarObservable(registro, 'impedimentos');
        this.adicionarObservable(registro, 'procurador');

        this.adicionarObservable(registro, 'movimentos', []);
        this.adicionarObservable(registro, 'composicao', []);
        registro.composicao.forEach((comp) => {
            this.adicionarObservable(comp, 'magistrado');
            this.adicionarObservable(comp.magistrado, 'presidenteSessao');
            this.adicionarObservable(comp.magistrado, 'ausente');
            this.adicionarObservable(comp.magistrado, 'impedido');
            this.adicionarObservable(comp.magistrado, 'situacaoImpedimento');
            this.adicionarObservable(comp.magistrado, 'suspeito');
            this.adicionarObservable(comp.magistrado, 'siglaSubstituto');
        });
        this.adicionarObservable(registro, 'ordemPreSessao');

        return registro;
    }

    parseNumeroProcesso = (numeroProcesso) => {
        let processo = {};
        processo.numero = '';
        processo.digito = '';
        processo.ano = '';
        processo.orgao = '';
        processo.regional = '';
        processo.vara = '';

        if (numeroProcesso) {
            let numeroSeparado = numeroProcesso.split('-');
            processo.numero = numeroSeparado[0];

            if (numeroSeparado[1]) {
                let restoNumeroUnico = numeroSeparado[1].split('.');
                processo.digito = restoNumeroUnico[0] ? restoNumeroUnico[0].toString().substring(0, 2) : '';
                processo.ano = restoNumeroUnico[1] ? restoNumeroUnico[1].toString().substring(0, 4) : '';
                processo.orgao = restoNumeroUnico[2] ? restoNumeroUnico[2].toString().substring(0, 1) : '';
                processo.regional = restoNumeroUnico[3] ? restoNumeroUnico[3].toString().substring(0, 2) : '';
                processo.vara = restoNumeroUnico[4] ? restoNumeroUnico[4].toString().substring(0, 4) : '';
            }
        }

        return processo;
    };

    tratarRedatorPje(registro) {
        if (registro?.processo?.origem === Configuracao.ORIGEM_PJE && registro?.informacoesAdicionais?.redator) {
            let redatorComposicao =
                registro.composicao &&
                registro.composicao.find(
                    (magistradoComposicao) =>
                        magistradoComposicao?.magistrado?.sigla === registro?.informacoesAdicionais?.redator
                );

            if (redatorComposicao) {
                registro.processo.redator = toJS(redatorComposicao.magistrado);
            } else {
                // TODO ajustar tratamento de erro
                console.info(
                    'O REDATOR ' +
                        registro.informacoesAdicionais.redator +
                        ' não faz parte da composição do processo ' +
                        registro.processo.numeroCompleto
                );
            }
        }
    }

    tratarPresidenteSessao(registro) {
        if (registro?.informacoesAdicionais?.siglaPresidente) {
            let presidenteComposicao =
                registro.composicao &&
                registro.composicao.find(
                    (magistradoComposicao) =>
                        magistradoComposicao?.magistrado?.sigla === registro?.informacoesAdicionais?.siglaPresidente
                );

            if (presidenteComposicao) {
                registro.presidenteSessaoJulgamento = toJS(presidenteComposicao.magistrado);
                registro.cargoSignatario = toJS(this.rootStore.dominioStore.getDescricaoCargo(registro.presidenteSessaoJulgamento.codigoCargo, registro.presidenteSessaoJulgamento.genero).descricaoCargo);
            } else {
                console.info(
                    'O PRESIDENTE ' +
                        registro.informacoesAdicionais.siglaPresidente +
                        ' não faz parte da composição do processo ' +
                        registro.processo.numeroCompleto
                );
            }
        }
    }

    configurarComposicao(registro) {
        // TODO arrumar após conclusão da issue SE-840
        registro.composicao.forEach((comp) => {
            comp.magistrado.presidenteSessao = comp.magistrado.presidenteSessao
                ? comp.magistrado.presidenteSessao
                : false;
            comp.magistrado.ausente = comp.magistrado.ausente ? comp.magistrado.ausente : false;
            comp.magistrado.suspeito = comp.magistrado.suspeito ? comp.magistrado.suspeito : false;
            //FIXME: deixar de utilizar siglaSubstituto e usar magistradoSubstituto.sigla
            comp.magistrado.magistradoSubstituto = comp.magistrado.magistradoSubstituto
                ? comp.magistrado.magistradoSubstituto
                : { sigla: '' };
            comp.magistrado.siglaSubstituto = comp.magistrado.magistradoSubstituto.sigla;
        });
    }

    montarComposicao(registro) {
        const composicao = registro.composicao || [];
        const impedimentos = registro.impedimentos || [];
        const processo = registro.processo;

        return composicao.map((comp) => {
            const mag = comp.magistrado;
            const impedimentoEncontrado = impedimentos.find((imp) => imp.magistrado.sigla === mag.sigla);

            const substituindo = mag.magistradoSubstituido
                ? {
                      sigla: mag.magistradoSubstituido.sigla,
                      nome: mag.magistradoSubstituido.nome
                  }
                : null;

            const substituto = composicao.find((c) => c.magistrado.magistradoSubstituido?.sigla === mag.sigla);
            const substituidoPor = substituto
                ? {
                      sigla: substituto.magistrado.sigla,
                      nome: substituto.magistrado.nome
                  }
                : null;

            return {
                nome: mag.nome,
                siglaDoMagistrado: mag.sigla,
                cpf: mag.cpf,
                genero: mag.genero,
                codigoCargo: mag.codigoCargo,
                converterSigla: !!mag.converterSigla,

                presidenteSessao: !!mag.presidenteSessao,
                ausente: !!mag.ausente,
                suspeito: !!mag.suspeito,

                situacaoImpedimento: impedimentoEncontrado
                    ? impedimentoEncontrado.situacaoImpedimento
                    : mag.situacaoImpedimento || undefined,

                relator: !!(processo.relator && processo.relator.sigla === mag.sigla),

                substituindo,
                substituidoPor
            };
        });
    }

    montarComposicaoComVotos(registro) {
        const votos = registro.votos || [];
        const composicao = registro.composicao || [];
        const impedimentos = registro.impedimentos || [];

        return composicao
            .map((comp) => {
                const mag = comp.magistrado;
                const sigla = mag.sigla;

                const impedido = !!impedimentos.find(
                    (imp) =>
                        imp.magistrado.sigla === sigla && imp.magistrado.situacaoImpedimento === 'IMPEDIMENTO_DECLARADO'
                );
                const possivelmenteImpedido = !!impedimentos.find(
                    (imp) =>
                        imp.magistrado.sigla === sigla && imp.magistrado.situacaoImpedimento !== 'IMPEDIMENTO_DECLARADO'
                );
                const ausente = !!mag.ausente;
                const voto = votos.find((v) => v.siglaDoMagistrado === sigla);

                const substituindo = mag.magistradoSubstituido
                    ? {
                          sigla: mag.magistradoSubstituido.sigla,
                          nome: mag.magistradoSubstituido.nome
                      }
                    : null;

                const substituto = composicao.find((c) => c.magistrado.magistradoSubstituido?.sigla === mag.sigla);
                const substituidoPor = substituto
                    ? {
                          sigla: substituto.magistrado.sigla,
                          nome: substituto.magistrado.nome
                      }
                    : null;

                const antiguidade = this.getAntiguidade(mag.sigla);

                return {
                    siglaDoMagistrado: mag.sigla,
                    nome: mag.nome,
                    cpf: mag.cpf,
                    genero: mag.genero,
                    codigoCargo: mag.codigoCargo,
                    presidenteSessao: !!mag.presidenteSessao,
                    relator: registro.processo.relator?.sigla === mag.sigla,
                    antiguidade,
                    voto: voto || null,
                    impedido,
                    possivelmenteImpedido,
                    suspeito: !!mag.suspeito,
                    ausente,
                    substituindo,
                    substituidoPor
                };
            })
            .filter((mag) => {
                return !mag.substituidoPor;
            })
            .sort((a, b) => a.antiguidade - b.antiguidade);
    }

    ordenarAdvogadosSustentacaoOral(registro) {
        if (registro.pedidoSustentacaoOral) {
            if (
                registro.pedidoSustentacaoOral.pedidosDetalhados &&
                registro.pedidoSustentacaoOral.pedidosDetalhados.length > 0
            ) {
                registro.pedidoSustentacaoOral.pedidosDetalhados.map((pedido) => {
                    if (pedido.advogados && pedido.advogados.length > 0) {
                        pedido.advogados = pedido.advogados.slice().sort((adv1, adv2) => {
                            return adv1.nome.localeCompare(adv2.nome);
                        });
                    }
                    return null;
                });
            }
        }
    }

    //utilizado para popular o código do procurador
    tratarProcurador(registro) {
        if (
            registro.procurador &&
            !registro.procurador.codigo &&
            registro.procurador.nome &&
            registro.procurador.genero
        ) {
            registro.procurador = this.rootStore.dominioStore.procuradores.find(
                (procurador) =>
                    procurador.origem === registro.processo.origem &&
                    procurador.nome === registro.procurador.nome &&
                    procurador.genero === registro.procurador.genero
            );
        }
    }

    segredoJustica(processo) {
        return processo.segredoJustica;
    }

    toggleExibirTodasAsSessoes = () => {
        this.exibirTodasAsSessoes = !this.exibirTodasAsSessoes;
    };

    toggleExibirSessoesPassadas = () => {
        this.exibirSessoesPassadas = !this.exibirSessoesPassadas;
    };

    get sessoesPassadasFiltradas() {
        return this.exibirSessoesPassadas
            ? this.sessoesComProcessos
            : this.sessoesComProcessos.filter(
                  (sessao) =>
                      moment(sessao.prazos.dataFimVotacaoVirtualExibicao, 'DD-MM-YYYY-HH-mm-ss')
                          .startOf('day')
                          .isSameOrAfter(moment().startOf('day')) ||
                      moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                          .startOf('day')
                          .isSameOrAfter(moment().startOf('day'))
              );
    }

    get sessoesComProcessos() {
        return this.exibirTodasAsSessoes
            ? this.sessoesJulgamento
            : this.sessoesJulgamento.filter((sessao) => sessao.quantidadeTotalProcessos);
    }

    get sessoesJulgamentoFiltradas() {
        if (this.sessoesJulgamento) {
            return this.sessoesPassadasFiltradas;
        }
        return [];
    }

    get sessoesJulgamentoFiltradasOrdenadas() {
        return this.sessoesJulgamentoFiltradas;
    }

    get isSessaoFinalizada() {
        const dataReferencia = this.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual
            ? this.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual
            : this.sessaoSelecionada?.prazos?.dataIniciaoSessaoPresencial;

        return moment(dataReferencia, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO).isBefore(moment());
    }

    async recarregarListaProcessos(notificarOrdenacao = true, ignorarCacheServidor = false) {
        if (this.sessaoSelecionada) {
            this.carregandoProcessos = true;
            let sessao = await this.sessaoService.recuperarSessaoJulgamento(
                this.idSessaoSelecionada,
                notificarOrdenacao,
                ignorarCacheServidor
            );

            if (sessao) {
                sessao = observable(sessao);
                this.configurarSessao(sessao);
                this.configurarProcessosSessao(sessao.processos);
                this.atualizarProcessoExpandido(this.processoExpandido);

                runInAction(() => {
                    this.sessaoSelecionada = sessao;
                    this.carregandoProcessos = false;
                    this.atualizarQtdProcessosListaSessoes();
                    this.mensagemOrdenacaoPendente = null;
                });
            }
        }
    }

    async recarregarListaProcessosSemCache() {
        return this.recarregarListaProcessos(false, true);
    }

    atualizarQtdProcessosListaSessoes() {
        if (this.sessaoSelecionada) {
            let sessao = this.sessoesJulgamento.find((sessao) => sessao.id === this.sessaoSelecionada.id);
            if (sessao) {
                sessao.quantidadeTotalProcessos = this.sessaoSelecionada?.quantidadeTotalProcessos
                    ? this.sessaoSelecionada.quantidadeTotalProcessos
                    : 0;
            }
        }
    }

    isMagistradoImpedido(siglaMagistrado, registro) {
        return (
            (registro.impedimentos || []).findIndex((impedimento) => {
                return impedimento.sigla === siglaMagistrado;
            }) > -1
        );
    }

    getAlertasInclusaoPautaSessao(processoPautavel, detalhes, composicaoPadrao) {
        let mensagens = [];
        let numeroCompleto = processoPautavel?.processo?.numeroCompleto || detalhes?.numeroCompleto;
        this.verificarAlertasPartes(numeroCompleto, mensagens);
        this.verificarAlertasComposicao(processoPautavel, detalhes, composicaoPadrao, mensagens);
        return mensagens;
    }

    verificarAlertasPartes(numeroCompleto, mensagens) {
        if (this.isParteEntePublico(numeroCompleto)) {
            mensagens.push('Existe ente público nas partes do processo');
        }
        if (this.isProcuradorParticipa(numeroCompleto)) {
            mensagens.push('MPT participa do processo como Custos Legis ou Polo ativo ou passivo');
        }
    }

    verificarAlertasComposicao(processoPautavel, detalhes, composicaoPadrao, mensagens) {
        let composicao = this.getComposicaoAlertas(processoPautavel, composicaoPadrao);
        let relator = (processoPautavel && processoPautavel.processo.relator) || (detalhes && detalhes.relator);

        if (composicao && composicao.length > 0) {
            if (!this.verificarRepresentanteDiferenteRelator(processoPautavel, relator, composicao, mensagens)) {
                if (this.verificarRelatorComposicao(relator, composicao, mensagens)) {
                    this.verificarRepresentanteRelatorComposicao(relator, composicao, mensagens);
                }
            }
            this.verificarRepresentantesMesmoOJC(composicao, mensagens);
            this.verificarQuorum(processoPautavel, composicao, mensagens);
        }
    }

    verificarRepresentanteDiferenteRelator(processoPautavel, relator, composicao, mensagens) {
        let representanteDiferente = false;

        if (relator && composicao && composicao.length > 0) {
            let magistradoComposicao = composicao.find((magistrado) => magistrado.magistrado.sigla === relator.sigla);

            if (magistradoComposicao && magistradoComposicao.magistrado.cpf !== relator.cpf) {
                representanteDiferente = true;
                mensagens.push(
                    'Na composição ' +
                        (this.existeComposicaoRemanescente(processoPautavel) ? 'remanescente' : 'da sessão') +
                        ' o representante do órgão julgador (' +
                        relator.sigla +
                        ') não é o relator do processo'
                );
            }
        }
        return representanteDiferente;
    }

    getComposicaoAlertas(processoPautavel, composicaoPadrao) {
        if (this.existeComposicaoRemanescente(processoPautavel)) {
            return processoPautavel.composicao;
        }
        return (
            composicaoPadrao &&
            composicaoPadrao.map((comp) => ({
                magistrado: comp.titular
            }))
        );
    }

    existeComposicaoRemanescente(processoPautavel) {
        return processoPautavel && processoPautavel.composicao && processoPautavel.composicao.length > 0;
    }

    verificarQuorum(processoPautavel, composicao, mensagens) {
        let magistrados = composicao.filter(
            (comp) =>
                !comp.magistrado.ausente &&
                (!processoPautavel || !this.isMagistradoImpedido(comp.magistrado.sigla, processoPautavel))
        );

        if (magistrados.length < this.sessaoSelecionada.quorum) {
            mensagens.push('Provável quórum mínimo não atingido ao considerar ausências e impedimentos');
        }
    }

    verificarRepresentantesMesmoOJC(composicao, mensagens) {
        let magistradosComposicao = {};
        composicao.forEach((comp) => {
            if (magistradosComposicao[comp.magistrado.sigla]) {
                mensagens.push(
                    'Há mais de um magistrado na composição do processo representando o mesmo OJC: ' +
                        comp.magistrado.sigla
                );
            } else {
                magistradosComposicao[comp.magistrado.sigla] = comp.magistrado;
            }
        });
    }

    verificarRepresentanteRelatorComposicao(relator, composicao, mensagens) {
        if (relator) {
            let magistrado = composicao.find((magistrado) => magistrado.magistrado.sigla === relator.sigla);

            if (magistrado && magistrado.magistrado.cpf !== relator.cpf) {
                mensagens.push(
                    'Na composição da sessão o representante do órgão julgador (' +
                        relator.sigla +
                        ') não é o relator do processo'
                );
            }
        }
    }

    verificarRelatorComposicao(relator, composicao, mensagens) {
        if (relator && relator.sigla && relator.cpf && !this.isRelatorComposicao(relator, composicao)) {
            mensagens.push(
                'Na composição da sessão o representante do órgão julgador (' +
                    relator.sigla +
                    ') não é o relator do processo'
            );
            return false;
        }
        return true;
    }

    isComposicoesIguais(composicao1, composicao2) {
        return (
            composicao1 &&
            composicao2 &&
            composicao1.length === composicao2.length &&
            composicao1.find((comp1) => !this.existeMagistradoComposicao(comp1.magistrado, composicao2)) === undefined
        );
    }

    isComposicaoIgualPadraoOJC(composicao) {
        return this.isComposicoesIguais(composicao, this.composicaoPadraoOJCNormalizada);
    }

    // Troca o nome do objeto de titular para magistrado, como é utilizado na composição do processo, para que seja possível a comparação
    get composicaoPadraoOJCNormalizada() {
        return this.composicaoPadraoOJC.map((composicao) => {
            let obj = {};
            let magistrado = composicao.substituto ? composicao.substituto : composicao.titular;
            obj.magistrado = {};
            obj.magistrado.sigla = magistrado?.sigla;
            obj.magistrado.cpf = magistrado?.cpf;
            return obj;
        });
    }

    existeMagistradoComposicao(magistrado, composicao) {
        return (
            composicao.findIndex(
                (comp) => magistrado.sigla === comp.magistrado.sigla && magistrado.cpf === comp.magistrado.cpf
            ) !== -1
        );
    }

    validarLocalizacaoMagistrado(magistrado, siglaOjc) {
        let magistradoLocalizacao = this.dominioStore.magistrados.find((mag) => mag.sigla === magistrado.sigla);
        return (
            magistradoLocalizacao?.localizacoes &&
            magistradoLocalizacao.localizacoes.findIndex((localizacao) => localizacao.siglaOjc === siglaOjc) !== -1
        );
    }

    async verificarLocalizacaoMagistrado(idSessao, magistrado) {
        return await this.sessaoService.verificarLocalizacaoMagistrado(
            idSessao,
            magistrado.sigla,
            magistrado.cpf,
            magistrado.converterSigla
        );
    }

    async recuperarComposicaoProcessoSessaoAnterior(registro) {
        if (!registro.composicaoSessaoAnterior) {
            if (!registro.julgamentosAnteriores) {
                registro.julgamentosAnteriores = await this.processoService.recuperarJulgamentosAnteriores(
                    registro.processo.numeroCompleto,
                    registro.processo.origem
                );
            }

            if (registro.julgamentosAnteriores && registro.julgamentosAnteriores.length > 0) {
                registro.julgamentosAnteriores
                    .slice()
                    .sort((j1, j2) =>
                        moment(j1.dataJulgamento, 'DD-MM-YYYY-HH-mm-ss').isAfter(
                            moment(j2.dataJulgamento, 'DD-MM-YYYY-HH-mm-ss')
                        )
                            ? -1
                            : 1
                    );

                let composicaoSessaoAnterior = await this.sessaoService.recuperarComposicaoProcessoSessao(
                    registro.julgamentosAnteriores[0].sessaoId,
                    registro.processo.numeroCompleto
                );

                if (composicaoSessaoAnterior) {
                    runInAction(
                        () =>
                            (registro.composicaoSessaoAnterior = composicaoSessaoAnterior.map((composicao) => ({
                                magistrado: composicao
                            })))
                    );
                }
            }
        }

        return registro.composicaoSessaoAnterior;
    }

    getDescricaoRelator(relator) {
        let nome = relator.nome;

        if (!nome) {
            let magistrado = this.rootStore.dominioStore.magistrados.find(
                (mag) => mag.sigla === relator.sigla && mag.cpf === relator.cpf
            );
            nome = magistrado?.nome;
        }

        return (relator.sigla ? relator.sigla : '') + (relator.sigla && nome ? ' - ' : '') + (nome || '');
    }

    isParteEntePublico(numeroCompleto) {
        let retorno = false;

        if (numeroCompleto && this.storeFuncionalidade.mapaProcessosPartes) {
            let partesProcesso = this.storeFuncionalidade.mapaProcessosPartes[numeroCompleto];

            if (partesProcesso?.partes) {
                retorno = partesProcesso.partes.findIndex((parte) => parte.entePublico) !== -1;
            }
        }

        return retorno;
    }

    isProcuradorParticipa(numeroCompleto) {
        let retorno = false;

        if (numeroCompleto && this.storeFuncionalidade.mapaProcessosPartes) {
            let partesProcesso = this.storeFuncionalidade.mapaProcessosPartes[numeroCompleto];

            if (partesProcesso?.partes) {
                retorno = partesProcesso.partes.find((parte) => this.isParteMPT(parte.nome)) !== undefined;
            }
        }

        return retorno;
    }

    isParteMPT(nomeParte) {
        return this.normalizarString(nomeParte).indexOf('ministerio publico do trabalho') === 0;
    }

    isRelatorComposicao(relator, composicao) {
        return (
            relator?.sigla &&
            relator.cpf &&
            composicao &&
            composicao.findIndex(
                (comp) => comp.magistrado.sigla === relator.sigla && comp.magistrado.cpf === relator.cpf
            ) !== -1
        );
    }

    novaPautaJulgamento(dataInicioSessaoPresencial) {
        return {
            prazos: {
                dataInicioVotacaoVirtual: '',
                dataFimVotacaoVirtual: '',
                dataInicioSessaoPresencial: dataInicioSessaoPresencial || '',
                dataPublicacaoPauta: '',
                dataDisponibilizacaoPauta: '',
                regrasResolucaoCnj591: !!this.isComponenteHabilitado('Resolucao591CNJ')
            },
            pautaLiberada: false,
            orgaoJudicante: {
                sigla: this.rootStore.usuarioStore.usuario.localizacao
            },
            tipo: Configuracao.TIPO_PAUTA_ORDINARIA,
            tipoJulgamento: MEIO_JULGAMENTO_SESSAO.SALA_DE_SESSAO_COM_PERIODO_VIRTUAL.codigo,
            id: `${Configuracao.ORIGEM_PJE}--`
            /*tipo: '',
            meioJulgumentoJulgamentoVirtual: false,
            meioJulgumentoSessaoJulgamento: false,
            modalidadeSessaoJulgamento: '',
            tipoJulgamento: '',
            id: ''*/
        };
    }
}
